//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Vyp.WebControls.VypraveniSettingsForm.ts                 </Name>
//    <Description> Uživatelské nastavení zásilek.                              </Description>
//    <Author>      JSindelka                                                      </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018                            </Copyright>
//    <Created>     2018-05-22                                                  </Created>
//  </FileHeader>

namespace Gordic.Vyp.AppSettings {
    /**
     * Cesta k objetu nastavení zásilky v GStore.
     * 
     * @author  JSindelka
     * @date    30.04.2019
     */
    export const VypBaseSettingsPath = "Global.Vyp.AppSettings.VypBaseSettings"

    /**
     * Vrátí hodnoty uživatelského nastavení zásilky.
     *
     * @author  JSindelka
     * @date    30.04.2019
     *  
     * @returns {Gordic.Vyp.WebControls.GVypBaseSettingsDto} Hodnoty uživatelského nastavení zásilky.
     */
    export function GetVypBaseSettings(): Gordic.Vyp.WebControls.GVypBaseSettingsDto {
        const settings: Gordic.Vyp.WebControls.GVypBaseSettingsDto | null | undefined = (window as any).gstor.get(VypBaseSettingsPath, true);
        if (settings) {
            return settings;
        } else {
            return {
                prevzit_dle_id_automaticky: false
            };
        }
    }

    /**
     * Nastaví hodnoty uživatelského nastavení zásilky.
     *  
     * @author  JSindelka
     * @date    30.04.2019
     *  
     * @param {Gordic.Vyp.AppSettings.GVypBaseSettingsDto | null} value Hodnoty uživatelského nastavení zásilky.
     */
    export function SetVypBaseSettings(value: Gordic.Vyp.WebControls.GVypBaseSettingsDto | null): void {
        (window as any).gstor.set(VypBaseSettingsPath, value);
    }

    /**
     * Formulář uživatelského nastavení vypravení.
     *
     * @author  JSindelka
     * @date    30.04.2019
     */
    export function VypBaseSettingsForm(): Forms.Form {
        const formName = "VypBaseSettingsForm";
        let modelProperty: (keyof Gordic.Vyp.WebControls.GVypBaseSettingsDto) | undefined;

        const form = new Gordic.Forms.Form({
            name: formName,
            tabOptions: {
                title: "jres:23900130", //RC 23900130 : Základní nastavení
                opened: false
            }
        } as any);

        form.addSection("jres:23900141") //RC 23900141 : Start aplikace
        form.addRow().addField("gcheck", "", { name: "spustitPosledniTask", model: VypBaseSettingsPath + "." + (modelProperty = "spustitPosledniTask"), label: "jres:23900142" }); //RC 23900142 : Spustit poslední otevřenou úlohu

        form.addSection("jres:23900131") //RC 23900131 : Automatický příjem zásilek dle ID
        form.addRow().addField("gcheck", "", { name: "prevzit_dle_id_automaticky", model: VypBaseSettingsPath + "." + (modelProperty = "prevzit_dle_id_automaticky"), label: "jres:23900132" }); //RC 23900132 : Zobrazit okno pro kontrolu zásilky a převzít
        return form;
    }
}